import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../../../hooks'
import { FormikField } from '../../../../Formik'
import { InputField } from '../../../../Input'
import {
  PROVIDER_FORM_EMAIL_FIELD_MAX_LENGTH,
  PROVIDER_FORM_FIELD_NAME_EMAIL,
} from '../../ProviderForm.constants'

function EmailField() {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  return (
    <FormikField
      hasCounter
      Component={InputField}
      borderless={!isMobileScreenSize}
      fieldComponentProps={{
        label: `${t('Provider.EmailFieldLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      inline={isMobileScreenSize}
      maxLength={PROVIDER_FORM_EMAIL_FIELD_MAX_LENGTH}
      name={PROVIDER_FORM_FIELD_NAME_EMAIL}
      placeholder={t('Provider.EmailFieldPlaceholderKey')}
    />
  )
}

export default EmailField
